import { Receipt } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Биллинг и себестоимость (БО-50, БО-51; ПОРТ-33, 34; ИНТ-40; НФТ-13; Приложение D «биллинг и себестоимость»):
 * счета (отметить оплату, аннулировать), оплаты и возвраты, сверка выписки, акты и ЭСФ, дебиторская задолженность,
 * себестоимость по клинике и врачу, маржа по тарифам. Чтение — DODOC_SUPPORT, изменения — DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.billing',
  area: 'backoffice',
  path: 'billing/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: Receipt,
  titleKey: 'finance:title',
  namespaces: ['backoffice', 'billing', 'tariffs', 'portal'],
  navGroup: 'finance',
  order: 200,
  load: () => import('./FinancePage'),
});
